import { useQuery, useMutation } from 'react-query';

import { getTemplatePreviewThumbnails } from 'api/TemplateIndexAPI';

export const useTemplatesPreviewQuery = (
  requestEnabled: boolean,
  templateIds: number[],
  queryKey: string,
) => {
  return useQuery({
    queryKey: [queryKey, templateIds],
    queryFn: () => getTemplatePreviewThumbnails(templateIds),
    enabled: requestEnabled,
  });
};

export type LazyTemplatePreviewParams = {
  templateIds: number[];
};
export const createLazyTemplatesPreviewQuery = ({ templateIds }: LazyTemplatePreviewParams) => {
  return getTemplatePreviewThumbnails(templateIds);
};
export const useLazyTemplatesPreviewQuery = () => {
  return useMutation({
    mutationFn: createLazyTemplatesPreviewQuery,
  });
};
